




















































import * as _ from 'lodash';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Guid } from 'guid-typescript';
import { Language, VisitorType, WindowState } from '../../types/Enum';
import { launchAndClearInterval } from '../../scripts/utils/Times';
import {
  IPortfolioWindow, IPortfolioWindowReduced, ShortCutIcon, SlotItem,
} from '../../types/Interface';
import Shortcut from './Shortcut.vue';
import BootMenu from './BootMenu.vue';
import WindowCustom from './Window.vue';
import { createWindow, createWindowProps } from '../../scripts/utils/WindowsCreator';

import WindowProperties from './WindowProperties.vue';
import { redirect } from '../../scripts/utils/redirect';
import APortfolioWindow from './APortfolioWindow';

@Component({
  components: {
    Shortcut,
    BootMenu,
    WindowCustom,
    WindowProperties,
  },
})
export default class Kernel extends Vue {
  private ShortCutData: ShortCutIcon[] = [
    { name: 'Qui suis-je ?', link: '/images/moi2.png', color: 'white' },
    { name: 'Expériences', link: '/images/icons/work.png', color: '#F8F8F8' },
    { name: 'Compétences', link: '/images/icons/skills.png', color: '#84F0DB' },
    { name: 'Diplômes', link: '/images/icons/degree2.png', color: 'transparent' },
    { name: 'Cv', link: '/images/icons/cv2.png', color: 'transparent' },
    { name: 'Contact', link: '/images/icons/contact.png', color: 'white' },
  ];

  private windows: Map<string, IPortfolioWindow> = new Map();

  private windowsReduced: Array<IPortfolioWindow> = new Array<IPortfolioWindow>();

  private bootMenu: boolean = false;

  public handleId:string = 'handle-id';

  public draggableValue: any = {
    handle: undefined,
  };

  public getImageFromTitle = (title: string) => {
    console.log(`Title de la fenetre reduite ! : ${title}`);
    const shortCut: ShortCutIcon | undefined = this.ShortCutData.find(x => x.name === title);

    return shortCut ? shortCut.link : undefined;
  };

  private redirect: Function = (title: string) => { redirect(title, this); };

  get allWindowsReduced(): IPortfolioWindow[] {
    const newarray: IPortfolioWindow[] = [];

    this.windows.forEach((value:IPortfolioWindow, key: string) => {
      if (value.state === WindowState.REDUCED) {
        newarray.push(value);
      }
    });
    return newarray;
  }

  public mounted() {
    this.draggableValue.handle = this.$refs[this.handleId];

    // WINDOWS PROPS SETTINGS
    this.$root.$on('Window::Props::Open', (item: SlotItem) => {
      const newWindow: IPortfolioWindow = createWindowProps(item.title) as IPortfolioWindow;

      this.handlingNewlyCreatedWindow(newWindow);
    });

    // WINDOWS NORMAL SETTINGS
    this.$root.$on('Window::Open', (item: SlotItem) => {
      const newWindow: IPortfolioWindow = createWindow(item.title, item.component) as IPortfolioWindow;

      this.handlingNewlyCreatedWindow(newWindow);
    });
  }

  private handlingNewlyCreatedWindow(newWindow: IPortfolioWindow) {
    const element: Element = (this.$refs.windowcontainer as Element);

    // if the windows is already registered
    if (this.windows.get(newWindow.id.toString())) {
      return;
    }
    // settings all events for the newly created windows
    newWindow.instance.$on('Window::Close', (item: IPortfolioWindowReduced) => {
      const fakeWindow: IPortfolioWindow | undefined = this.windows.get(item.id);
      if (!fakeWindow || _.isNil(fakeWindow)) {
        console.log('Window');
        return;
      }
      this.windowsReduced = this.allWindowsReduced;
      console.log(`Closing event ! Taille fenetre :${this.windows.size}`);
      // (fakeWindow.instance as APortfolioWindow).close();
      this.windows.delete(item.id);
      console.log(`Closing event ! Taille fenetre :${this.windows.size}`);
      this.windowsReduced = this.allWindowsReduced;
      // fakeWindow.instance.$destroy();
    });
    newWindow.instance.$on('Window::Reduce', (item: IPortfolioWindowReduced) => {
      newWindow.state = WindowState.REDUCED;
      this.windowsReduced.push(newWindow);
      console.log('Reduce event !');
      console.log(this.windowsReduced);
    });
    newWindow.instance.$on('Window::Focus::Get', (item: IPortfolioWindowReduced) => {
      this.focusManagementWindow(item.id);
    });
    // Add it to the handlers
    this.windows.set(newWindow.id.toString(), newWindow);
    if (!_.isNil(element)) {
      element.appendChild(newWindow.instance.$el);
    }
  }

  private focusManagementWindow(id: string) {
    console.log(`Taille du tableau de fenetre :${this.windows.size}`);
    this.windows.forEach((value:IPortfolioWindow, key: string) => {
      if (key === id && value.instance) {
        console.log(`${id}Get the focus ! `);
        (value.instance as APortfolioWindow).addFocus();
      } else if (!_.isNil(value)) {
        console.log(`${id}lose the focus ! `);
        (value.instance as APortfolioWindow).removeFocus();
      } else {
        console.log("la valeur de l'element a focus est undefined");
        console.log(value);
      }
    });
  }

  private boot() {
    if (this.bootMenu === true) { this.bootMenu = false; } else { this.bootMenu = true; }
  }

  private openReducedWindow(id: string) {
    console.log(`Ouverture d'une fenetre reduite ${id}`);
    const fakeWindowReduced: IPortfolioWindow[] | undefined = this.windowsReduced.filter((val) => {
      if (val.id.toString() === id) {
        return true;
      }
      return false;
    });

    if (!fakeWindowReduced) {
      console.log(`id de la fenetre n'existe pas !${id}`);
      return;
    }
    (fakeWindowReduced[0].instance as APortfolioWindow).open();
    fakeWindowReduced[0].state = WindowState.OPENED;
    this.windowsReduced = this.windowsReduced.filter((val) => {
      if (val.id.toString() === id) {
        return false;
      }
      return true;
    });
  }

  private setVisitor(type: VisitorType): void {
  }
}
